import Immutable from 'immutable';

const LOAD = 'tag/LOAD';
const LOAD_SUCCESS = 'tag/LOAD_SUCCESS';
const LOAD_FAIL = 'tag/LOAD_FAIL';


const initialState = Immutable.fromJS({
  allTags: [],
  loading: false,
  errorMessage: null
});

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case LOAD:
      return state
        .set('loading', true)

    case LOAD_FAIL:
      return state
        .set('loading', false)
        .set('errorMessage', action.errorMessage);

    case LOAD_SUCCESS:
      return state
        .set('loading', false)
        .set('allTags', action.tags);


    default:
      return state;
  }
}

export const getTags = () => async (dispatch, getState, api) => {

  dispatch({ type: LOAD });

  try {
    const res = await api.get('/tags');
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch({ type: LOAD_SUCCESS, tags: res });
  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error });
  }
};

export const deleteTag = (id) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.del(`/tags/${id}`);
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    const tags = getState().get('tag').get('allTags');
    dispatch({ type: LOAD_SUCCESS, tags: Object.assign([], tags.filter(t => t.id !== id)) });
    return tags;
  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error });
  }
};

export const addTag = (tag) => async (dispatch, getState, api) => {
  const tags = getState().get('tag').get('allTags');
  const found = tags.some(t => t.id === tag.id);

  // push in list only when it is not there
  if(!found) {
    tags.push(tag);
    dispatch({ type: LOAD_SUCCESS, tags: Object.assign([], tags) });
  } 
}



// WEBPACK FOOTER //
// ./src/redux/modules/tag.js